import { IVariant, Purchase } from '../interfaces/shopify.interface';
import axios from 'axios';
import {
  Matching,
  ShopSettings
} from '../interfaces/ProductService.interface';
import storageService from './StorageService';
import { ConversionsService } from './ConversionsService';
import log from '../services/LogService';

interface PurchaseData {
  purchase: Purchase;
  article: any;
  matching: any;
  service: any;
}

interface ShopifyVariant {
  id: number | string;
  name: string;
  price: number;
  public_title: string;
  sku: string;
}

const defaultSizePattern = /^EU (\d+[.]?\d+?) \/ US (\d+[.]?\d+?)$/;
// Baabuk /^(\d{2})/

function getVariantSize(variant: ShopifyVariant, settings: ShopSettings) {
  const title = variant.public_title;
  const pattern = new RegExp(settings.sizePattern) || defaultSizePattern;

  if (!pattern.test(title)) {
    return title;
  }

  const match = pattern.exec(title);
  const euSize = match[1];
  // const usSize = match[2];
  return euSize;
}

export const ShopifyHelper = {

  handleAddToCart(matching: Matching, settings: ShopSettings) {

    log.info('handle matching Shopify');

    const variants = this.getArticleVariants(settings);

    const variant = variants.find(
      item => item.size == matching.size.value && item.available);

    if (!variant) {
      alert('ERROR: Shoe Size not found');
      return Promise.reject();
    }

    storageService.addMatching(matching, this.articleId);
    storageService.update('measurementId', matching.measurement_id);

    const form = new FormData();

    form.append('Size', variant.size);
    form.append('form_type', 'product');
    form.append('utf8', '✓');
    // form.append('return_to', '/checkout');
    form.append('id', '' + variant.id);
    form.append('footprint_id', matching.matching_id);

    // const options = { headers: {} };
    // options.headers['X-CSRF-Token'] = csrfToken;

    return axios.post('/cart/add', form)
      .then(response => {
        log.info('Add To cart response', response);
        window.location.href = '/cart';
      });
  },

  getArticlePriceFromVariant(variant) {
    const { price } = variant;

    if (!price || Number.isNaN(price) || Number.isNaN(Number.parseInt(price))) {
      return null;
    }

    return price / 100;
  },

  isCheckout() {
    return window.location.pathname.includes('checkouts');
  },

  getArticleVariants(settings: ShopSettings): Array<IVariant> {
    const productData = (window as any).meta?.product;

    return productData.variants.map((item) => {
      return {
        id: item.id,
        available: true,
        size: getVariantSize(item, settings),
      };
    });

  },

  processPurchase(purchaseData: PurchaseData) {

    log.info('processing purchase', purchaseData);
    const { matching, purchase, article, service } = purchaseData;

    const data = {
      matching_id: matching.matching_id,
      price: Number(article.price),
      quantity: Number(article.quantity),
      tax: Number(purchase.tax),
      total: Number(purchase.value),
      currency: purchase.currency,
      client_session_id: '' + purchase.transaction_id,
    };

    log.info('posting conversion', data);

    return service.postConversion(data);
  },

  isPurchase() {
    log.warn('Abstract isPurchase called');
    return false;
  },

  getPurchase():Purchase {
    log.warn('Abstract getPurchase called');
    return null;
  },

  getApiKey() {
    log.warn('Abstract getApiKey called');
    return '';
  },

  findArticlePurchaseData(id:string, purchase:any) {
    log.info('Looking for purchase with id', id);
    return purchase.items.find(item => item.id == id);
  },

  handleCheckout() {

    const isPurchase = this.isPurchase();

    if (!isPurchase) {
      const err = new Error('No data found for FPT purchase');
      return Promise.reject(err);
    }

    const fptSessionStr = sessionStorage.getItem('fpt-session');

    if (!fptSessionStr) {
      const err = new Error('No purchase data found');
      return Promise.reject(err);
    }

    const fptSession = JSON.parse(fptSessionStr);
    const articles = Object.getOwnPropertyNames(fptSession.matchings);

    if (articles.length == 0) {
      log.info('No matchings found', fptSession.matchings);
      return Promise.resolve(null);
    }

    log.info('searching for purchase');
    const purchase = this.getPurchase();

    if (!purchase) {
      const err = new Error('unable to identify purchase object');
      return Promise.reject(err);
    }

    log.info('found purchase', purchase);

    const conversionsService = new ConversionsService({
      apiKey: this.getApiKey(),
      baseUrl: process.env.API_URL,
    });

    const filteredArticles = articles.filter(
      articleId => this.findArticlePurchaseData(articleId, purchase));

    if (!filteredArticles.length) {
      log.info('no FPT matchings found');
    }

    const promises = filteredArticles.map(articleId => this.findArticlePurchaseData(articleId, purchase))
      .map(item => this.processPurchase({
        purchase,
        article: item,
        matching: fptSession.matchings['' + item.id],
        service: conversionsService,
      }));

    return Promise.all(promises);
  }

}
